import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';
import { HeaderService } from '../../../../Services/HeaderService';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-cards-style1',
	templateUrl: './cards-style1.component.html',
	styleUrls: ['./cards-style1.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class CardsStyle1Component implements OnInit {

	@ViewChild('container', { read: ElementRef }) container: ElementRef;
	@ViewChild('code', { read: ElementRef }) code: ElementRef;

	private subscription: Subscription[] = [];
	public data: string = '';
	public showCode = '';

	constructor(public _dataService: DataService, private cdRef: ChangeDetectorRef, private _headerService: HeaderService, private _titleService: Title) {
		_titleService.setTitle('Cards');
		_dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(value => {
			this.showCode = value;
		})
	}

	ngOnInit() {
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}

	ngOnDestroy(): void {
		this.subscription.map(subscription => {
			subscription.unsubscribe();
		})
	}



	ShowCode(event) {
		this.data = this.container.nativeElement.innerHTML;
		if (this.showCode == 'cards-style1') {
			this._dataService.setState('');
		} else {
			this._dataService.setState('cards-style1');
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/features/cards/cards-style1/cards-style1.component.ts